export default __webpack_public_path__ + "static/media/p12.c7c7fdc5.jpg";